import React, { useCallback, useContext } from 'react';
import { ReactReduxContext } from 'react-redux';

// react-bootstrap 0.31's OverlayTrigger mounts its overlay with
// ReactDOM.unstable_renderSubtreeIntoContainer, a separate legacy React root
// that only forwards legacy context — react-redux 8's ReactReduxContext
// (React.createContext) never reaches it, so any connect()ed component
// rendered inside an overlay finds a null context and crashes. Capture the
// context value here, on the Provider side of that seam, and re-provide it
// around the element that gets rendered into the overlay.
export const useStoreContextBridge = () => {
    const contextValue = useContext(ReactReduxContext);
    return useCallback(
        element => <ReactReduxContext.Provider value={contextValue}>{element}</ReactReduxContext.Provider>,
        [contextValue]
    );
};
